module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step1_Image17.9fe62c59.jpg";